<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Analyte Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <analyte-card v-if="analyte" :analyte="analyte" />
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Analyte Info</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Sample Type" :label-cols="2" >
                <div>
                  <multiselect
                    v-model="selected_sample_type"
                    :value="sample_type_value"
                    :options="sample_type_options"
                    :multiple="false"
                    track-by="id"
                    label="name"
                  />
                </div>
              </b-form-group>
              <b-form-group label="Name" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Analyte Name"
                />
              </b-form-group>
              <b-form-group label="Abbreviation" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.abbrev"
                  placeholder="Analyte Abbreviation"
                />
              </b-form-group>
              <b-form-group label="MODUS Name" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.modus_name"
                  placeholder="MODUS Name"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Analyte Description"
                />
              </b-form-group>
              <b-form-row class="mb-3">
                <b-col cols="2">Range</b-col>

                <b-col>
                  <b-form-input
                    type="number"
                    v-model="form_data.range_min"
                    placeholder="Min"
                  />
                </b-col>

                <b-col>
                  <b-form-input
                    type="number"
                    v-model="form_data.range_max"
                    placeholder="Max"
                  />
                </b-col>
              </b-form-row>
              <b-form-group label="Range Unit" :label-cols="2">
                <b-form-select
                  :options="measure_unit_options"
                  v-model="measure_unit_value"
                >
                  <template #first>
                    <option :value="null" disabled>
                      Select Type
                    </option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Grind Key" :label-cols="2" description="Indicator used to group analytes together for sample prep grinding processes.">
                <b-form-input
                  type="text"
                  v-model="form_data.grind_key"
                  placeholder="Grind Key"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
            ><i class="fal fa-address-book" /> Save</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import AnalyteCard from "@/components/lab/analyte/AnalyteCard";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "AnalyteForm",
  components: {
    AnalyteCard,
    Multiselect
  },
  props: {
    analyte: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: true,
      form_data: {
        name: null,
        abbrev: null,
        modus_name: null,
        description: null,
        sample_type_id: null,
        range_min: null,
        range_max: null,
        range_unit_id: null,
        grind_key: null,
      },
      sample_type_collection: null,
      sample_type_options: null,
      sample_type_value: null,

      measure_unit_collection: null,
      measure_unit_options: null,
      measure_unit_value: null
    };
  },
  computed: {
    selected_sample_type: {
      get() {
        return this.sample_type_value;
      },
      set(value) {
        this.sample_type_value = value;
        this.form_data.sample_type_id = value && value.id;
      }
    }
  },
  methods: {
    initFormData() {
      const { description, modus_name, sample_type_id } = this.analyte;

      this.form_data = {
        ...this.analyte.cloneAttributes(true, true, [
          "id",
          "sample_type",
          "analytes"
        ]),
        modus_name,
        description
      };

      sample_type_id &&
        (this.sample_type_value = this.sample_type_options.find(
          ({ id }) => id === sample_type_id
        ));
    },
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        message: this.$bvToast
      });

      this.sample_type_options = this.sample_type_collection.models.map(
        ({ id, name }) => {
          return {
            id,
            name
          };
        }
      );

      this.measure_unit_collection = await getCollection({
        collection_type: "measure_unit",
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        message: this.$bvToast
      })

      this.measure_unit_options = this.measure_unit_collection.models.map(
        ({ id, abbrev }) => {
          return {
            value: id,
            text: abbrev
          };
        }
      );

      this.analyte && this.initFormData();

      this.loading = false;
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
